import React from 'react';

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css'

import FormbuilderFieldWrapper from './formbuilderFieldWrapper';

class FormbuilderPhoneNumber extends React.Component {

    render() {
        const { onChange, value, placeholder, label, validation, error, errorMessage, onBlur, inputSub, popup, organizationCountry, initialValidation } = this.props;

        return (
            <FormbuilderFieldWrapper label={label}
                validation={validation}
                error={error}
                errorMessage={errorMessage}
                onBlur={onBlur}
                inputSub={inputSub}
                popup={popup}
                value={value}
                initialValidation={initialValidation}>
                <PhoneInput id='formbuilder-phone'
                    onChange={onChange}
                    country="AU" //TODO: set organization's country when API will be ready
                    value={value}
                    defaultCountry={organizationCountry}
                    placeholder={placeholder} />
            </FormbuilderFieldWrapper>
        );
    }
}

export default FormbuilderPhoneNumber;